export default "__VITE_ASSET__388f2bc6__"